import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { currentBookingAtom } from "../../stores";

/**
 * Will get the round by ID or by new round internal ID.
 */
export const getRoundFromIdAtom = atomFamily((roundId: string) => {
  return atom((get) => {
    const booking = get(currentBookingAtom);
    const rounds = booking?.rounds;
    return rounds?.find((r) => r.localId === roundId) ?? null;
  });
});
